module.exports = __webpack_public_path__ + "static/media/Cuadricula_1.105a4644.svg";